exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.GiftNumber {\r\n  color: #222 !important;\r\n  padding: 0.26667rem 0.42667rem;\n}\n.GiftNumber .van-picker {\r\n  height: 100% !important;\n}\r\n", ""]);

// exports
